import { mainApiAxios as axios } from '@/plugins/axios'


export default {

    addAttachment(formdata) {
        return axios.post('elibraries', formdata, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    updateOrder(obj) {
        return axios.post('elibraries/updateOrder', obj)
    },
    loadCategory(categoryId) {
        return axios.get(`elibraries/${categoryId}`)
    },

    deleteElibrary(attachmentId) {
        return axios.post(`elibraries/attachment/delete/${attachmentId}`)
    },

    getAttachment(recordId) {
        return axios.get(`elibraries/attachment/${recordId}`)
    }
}